import { get } from 'axios'

export const requestBenchmarkByGroup = groupId => {
  return get(`benchmarks/${groupId || 'company'}`).then(res => {
    if (!res.data) return {}
    return res.data
  })
}

export default {
  requestBenchmarkByGroup,
}
